export const DEFAULT_LAST_CONSUMED_MESSAGE_INDEX = -1;
